import warehouseGoods from './warehouse-goods/index.vue';
import warehouseGoodsDetail from './warehouse-goods/detail.vue';
import warehouseOrder from './warehouse-order/index.vue';
import warehouseUnmannedOrder from './warehouse-unmanned-order/index.vue';
import warehouseOrderDetail from './warehouse-order/detail.vue';
import warehouseDemand from './warehouse-demand/index.vue';
import warehouseReplenish from './warehouse-replenish-list/index.vue';
import warehouseInventory from './warehouse-inventory/index.vue';
import warehouseInventoryDetail from './warehouse-inventory/detail.vue';
import warehousePayment from './warehouse-payment/index.vue';
import warehousePaymentRefund from './warehouse-payment-refund/index.vue';
import warehouseVeterinaryZsm from './warehouse-veterinary-zsm/index.vue';
import warehouseVeterinaryUpload from './warehouse-veterinary-upload/index.vue';
import warehouseVeterinaryReceipt from './warehouse-veterinary-receipt/index.vue';
import warehouseVeterinaryPrescription from './warehouse-veterinary-prescription/index.vue';
import warehousePurchase from './warehouse-purchase/index.vue';
import warehouseSurvey from './warehouse-survey/index.vue';

export default [
    {
        name: '商品库存',
        path: '/warehouse/warehouse-goods',
        component: warehouseGoods,
    },
    {
        name: '库存详情',
        path: '/warehouse/warehouse-goods-detail',
        component: warehouseGoodsDetail,
    },
    {
        name: '订单记录',
        path: '/warehouse/warehouse-order',
        component: warehouseOrder,
    },
    {
        name: '渠道订单',
        path: '/warehouse/warehouse-unmanned-order',
        component: warehouseUnmannedOrder,
    },
    {
        name: '订单详情',
        path: '/warehouse/warehouse-order-detail',
        component: warehouseOrderDetail,
    },
    {
        name: '采购记录',
        path: '/warehouse/warehouse-purchase',
        component: warehousePurchase,
    },
    {
        name: '采购记录',
        path: '/warehouse/warehouse-survey',
        component: warehouseSurvey,
    },
    {
        name: '补货记录',
        path: '/warehouse/warehouse-replenish',
        component: warehouseReplenish,
    },
    {
        name: '要货记录',
        path: '/warehouse/warehouse-demand',
        component: warehouseDemand,
    },
    {
        name: '库存记录',
        path: '/warehouse/warehouse-inventory',
        component: warehouseInventory,
    },
    {
        name: '库存记录详情',
        path: '/warehouse/warehouse-inventory-detail',
        component: warehouseInventoryDetail,
    },
    {
        name: '付款记录',
        path: '/warehouse/warehouse-payment',
        component: warehousePayment,
    },
    {
        name: '退款记录',
        path: '/warehouse/warehouse-payment-refund',
        component: warehousePaymentRefund,
    },
    {
        name: '追溯查询',
        path: '/warehouse/warehouse-veterinary-zsm',
        component: warehouseVeterinaryZsm,
    },
    {
        name: '上传记录',
        path: '/warehouse/warehouse-veterinary-upload',
        component: warehouseVeterinaryUpload,
    },
    {
        name: '经营台账',
        path: '/warehouse/warehouse-veterinary-receipt',
        component: warehouseVeterinaryReceipt,
    },
    {
        name: '处方管理',
        path: '/warehouse/warehouse-veterinary-prescription',
        component: warehouseVeterinaryPrescription,
    },
];
